import React, {Component} from "react";
import {Buffer} from "buffer";
import {Button, Card, Col, Form, Modal, Row, Typography} from "antd";
import Cookies from "universal-cookie";
import {sendIdealMessageService} from "../../../services/ideal/SendIdealMessageService";

const {Text} = Typography;

class CreditConfirm extends Component<any, any> {
    private readonly initState!: any;
    private user = JSON.parse(Buffer.from(new Cookies().get('_u'), "base64").toString())

    constructor(props: any) {
        super(props);
        this.initState = {
            offerCode: "",
            ownerPhoneNumber: "",
            updateProcess: false,
        }
        this.state = {...this.initState}
    }

    async componentDidMount() {
        await this.promisedSetState({
            offerCode: this.props.offerCode,
            ownerPhoneNumber: this.props.ownerPhoneNumber,
        });
    }

    async componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<any>, snapshot?: any) {
        if (this.props.time !== prevProps.time) {
            await this.promisedSetState({
                offerCode: this.props.offerCode,
                ownerPhoneNumber: this.props.ownerPhoneNumber,
            });
        }
    }

    onProcess = async () => {
        if (!this.state.ownerPhoneNumber) {
            Modal.error({
                title: 'Error',
                content: 'Nomor Telpon tidak valid'
            });
            return;
        }

        this.setState({
            updateProcess: true,
        });

        let phoneTarget = this.state.ownerPhoneNumber;
        phoneTarget = (phoneTarget.substring(0, 2) === "08") ? phoneTarget.replace(/^.{2}/g, '628') : phoneTarget;

        const dataSendToWhatsapp = {
            target: phoneTarget,
            template_name: "credit_confirm",
            area: this.props.offerData?.area?.toUpperCase(),
            offer:{
                purchaseScheme: this.props.offerData?.purchase_method,
                createdAt: this.props.offerData?.transaction_time,
                offerCode: this.state.offerCode
            },
            contactName: this.props.offerData?.id_card_owner?.full_name?.toUpperCase(),
            vehicle: this.props.offerData?.vehicle,
            components: [{
                type: "body",
                parameters: [
                    {
                        type: "text",
                        text: this.props.offerData?.id_card_owner?.full_name?.toUpperCase()
                    },
                    {
                        type: "text",
                        text: this.props.offerData?.vehicle?.variant_name?.toUpperCase()
                    },
                    {
                        type: "text",
                        text: this.props.offerData?.vehicle?.color_name?.toUpperCase()
                    }
                ]
            }],
        }

        try {
            await sendIdealMessageService.sendMessage(
                dataSendToWhatsapp
            ).then(async successData => {
                Modal.success({
                    title: 'Proses Sukses',
                    content: 'Pesan dalam proses pengiriman'
                });
                this.props.onCloseProps("close");
                await this.promisedSetState({
                    updateProcess: false,
                });
            });
        } catch (e) {
            Modal.error({
                title: 'Proses Gagal',
                content: ' ' + e
            });
            await this.promisedSetState({
                updateProcess: false,
            });
        }
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>
                <div>
                    <div style={{fontSize: "60%", color: "grey", textAlign: "right", marginBottom: 10}}>KodeTemplate: credit_confirm</div>
                    <Form layout="vertical">
                        <Row style={{marginBottom: 7}}>
                            <Col xs={24} xl={8} className={`col-grey`}>Kode Offer:</Col>
                            <Col xs={24} xl={16}>{this.state.offerCode}</Col>
                        </Row>
                        <Row style={{marginBottom: 7}}>
                            <Col xs={24} xl={8} className={`col-grey`}>Nomor Telpon:</Col>
                            <Col xs={24} xl={16}>{this.state.ownerPhoneNumber}</Col>
                        </Row><br/>

                        <i>Isi Pesan Whatsapp:</i>
                        <Card>
                            <Text style={{fontSize: "90%", color: "gray"}}>
                                Pengajuan kredit atas nama {this.props.offerData?.id_card_owner?.full_name?.toUpperCase()} sudah disetujui untuk tipe {this.props.offerData?.vehicle?.variant_name?.toUpperCase()} dengan warna {this.props.offerData?.vehicle?.color_name?.toUpperCase()}. Apakah anda ingin melanjutkan proses kredit ini?
                            </Text>
                        </Card><br/>

                        <Button type={"primary"} loading={this.state.updateProcess} onClick={() => this.onProcess()}> Kirim Konfirmasi Kredit Ke Nomor Tersebut</Button>
                    </Form>
                </div>
            </React.Fragment>
        );
    }
}

export default CreditConfirm;